/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Loader from "components/loader/Loader";
import toast from "react-hot-toast";
import { previewEmailAPI } from "Api/emailAPI";
import { consoleLog } from "helpers";

const exemptTemplates = ["WELCOME", "RESETPASSWORD", "PROFILEUPDATE"];

const PreviewEmailModal = ({ isOpen, onClose, previewEmailFormData }) => {
  const [previewEmailData, setPreviewEmailData] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;

    const fetchData = async () => {
      setIsLoading(true);
      const token = localStorage.getItem("jwtToken");

      const payload = { ...previewEmailFormData, isPreview: true };
      if (exemptTemplates.includes(payload.emailTypes)) {
        delete payload.itineraryId;
      }
      payload.template = payload.emailTypes;
      consoleLog(["📤 Modal preview payload:", payload]);

      try {
        const response = await previewEmailAPI(payload, setIsLoading, token);
        consoleLog(["📝 Raw previewEmailAPI result:", response]);
        if (response?.html) {
          setPreviewEmailData(response.html);
        } else {
          throw new Error("Missing html in response");
        }
      } catch (err) {
        console.error("Error previewing Email:", err);
        toast.error("Failed to preview email");
        handleCancel();
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [isOpen, handleCancel]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="bg-black fixed inset-0 z-[100] bg-opacity-75 transition-opacity"
        onClick={handleCancel}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-[101] flex h-screen items-center justify-center">
        <div className="relative z-50 mx-auto max-h-[90dvh] w-auto min-w-[300px] overflow-auto rounded-xl bg-white p-6 shadow-xl">
          <IoMdClose
            onClick={handleCancel}
            className="absolute top-4 right-4 cursor-pointer text-gray-600 hover:text-gray-800"
            size={24}
          />

          {isLoading ? (
            <div className="flex h-[200px] w-full items-center justify-center">
              <Loader />
            </div>
          ) : (
            <div className="prose prose-lg max-w-none">
              <h2 className="mb-4 text-center text-2xl font-semibold text-gray-800">
                Preview
              </h2>
              <div
                onClick={(e) => e.preventDefault()}
                dangerouslySetInnerHTML={{ __html: previewEmailData }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewEmailModal;
